import React from 'react';
import SectionHeader from '../../ui/SectionHeader';
import AboutCard from './AboutCard';
import '../../../styles/components/sections/About.css';

const About = () => {
  const aboutData = [
    {
      icon: '📱',
      title: 'Beskontaktna kontrola',
      description: 'Zaboravi na sitne novčanice na perionici. Sve rešava tvoj telefon – skeniraj QR kod i kreni sa pranjem u sekundi.',
      features: ['Instant dobijanje žetona', 'Digitalni žetoni', 'Bez fizičkog kontakta'],
      delay: '0.1s'
    },
    {
      icon: '💎',
      title: 'Premium pretplata',
      description: 'Prva prava pretplata za automobile u regionu. Izaberi paket koji ti odgovara i uživaj u neograničenoj čistoći.',
      features: ['Fiksni mesečni trošak', 'Više nivoa usluge', 'Bez skrivenih troškova'],
      delay: '0.2s'
    },
    {
      icon: '🚀',
      title: 'Moderna mreža',
      description: 'Postani deo ClickWash zajednice koja postavlja nove standarde u održavanju vozila na najprometnijim lokacijama.',
      features: ['Pametna mapa perionica', 'Ušteda vremena', 'Vrhunski sjaj uvek'],
      delay: '0.3s'
    }
  ];

  return (
    <section id="about" className="about-section">
      <div className="container">
        <SectionHeader
          badge="O NAMA"
          title="Budućnost pranja automobila"
          subtitle="Spojili smo najmoderniju tehnologiju sa tvojom potrebom za brzim i kvalitetnim održavanjem vozila."
          icon="✨"
        />
        
        {/* BITNO: Klasa mora biti about-grid */}
        <div className="about-grid">
          {aboutData.map((item, index) => (
            <AboutCard key={index} {...item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;